import {
    NinchatActionType,
    NinchatGetAudienceRangeCommentsAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const getAudienceRangeComments = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatGetAudienceRangeCommentsAction}`,
    async (arg: NinchatActionParams<NinchatGetAudienceRangeCommentsAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatGetAudienceRangeCommentsAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
